/*eslint-disable no-unused-vars*/
/*eslint-disable no-trailing-spaces*/
// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.
/**
 * Theme customizer header-menu js
 * @copyright (c) 2021 WisdmLabs (https://wisdmlabs.com/) <support@wisdmlabs.com>
 * @license   http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 * @author    Yogesh Shirsath
 */

import $ from 'jquery';
import Utils from 'theme_remui/customizer/utils';

var applySiteColorToHeader = false;
/**
 * Selectors
 */
var SELECTOR = {
    BASE: 'header-menu',
    SITECOLOR: '[name="sitecolorhex"]',
    NAVBARINVERSE: '[name="navbarinverse"]',
};

function handleSiteColorToHeader() {
    applySiteColorToHeader = $(SELECTOR.NAVBARINVERSE).is('checked');
    if (!applySiteColorToHeader) {
        return;
    }
    let color = $(SELECTOR.SITECOLOR).spectrum('get').toString();

}

/**
 * Apply settings.
 * @returns {void}
 */
function apply() {
    // /* eslint-disable no-useless-escape */
    // let content = ``;
    // Utils.putStyle(SELECTOR.BASE, content);
}

/**
 * Initialize events.
 */
function init() {
    apply();

    // Navbar inverse.
    $(SELECTOR.NAVBARINVERSE).on('change', handleSiteColorToHeader);
}

export default {
    init,
    apply
}